import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Table as TableComponent } from '@src/shared/ui/components/TableStatic';
import { Tooltip } from '@uhg-abyss/web/ui/Tooltip';
import { orderBy } from 'lodash';
import React, { useMemo } from 'react';

import configuration from './includes/configuration.json';

/**
 * Table: Top 25 Sources
 *
 * Displays a list of top 25 data containment sources.
 *
 * @param rows
 * @returns {Element}
 * @constructor
 */
export function Table({ rows = [] }) {
  /**
   * renderCellRank
   *
   * Displays the rank of the source within a cell.
   *
   * @param row
   * @param cell
   * @returns {React.JSX.Element|*}
   */
  const renderCellRank = ({ cell, row }) => {
    return <div>{cell?.value}</div>;
  };

  /**
   * renderCellContained
   *
   * Displays the contained amount of the source within a cell.
   *
   * @param row
   * @param cell
   * @returns {React.JSX.Element|*}
   */
  const renderCellContained = ({ cell, row }) => {
    return <div>{cell?.value}</div>;
  };

  /**
   * renderCellCSource
   *
   * Displays the contained amount of the source within a cell.
   *
   * @param row
   * @param cell
   * @returns {React.JSX.Element|*}
   */
  const renderCellSource = ({ cell, row }) => {
    return (
      <Tooltip content={row?.original?.sourceName}>
        <span>{cell?.value}</span>
      </Tooltip>
    );
  };

  /**
   * Columns for table.
   */
  const columns = useMemo(() => {
    return orderBy(configuration?.initialColumns, ['order'], ['asc']).map((item) => {
      const column = item;

      if (column.Header === 'Rank') {
        column.Cell = renderCellRank;
      }

      if (column.Header === 'Contained') {
        column.Cell = renderCellContained;
      }

      if (column.Header === 'Source Tag') {
        column.Cell = renderCellSource;
      }

      return column;
    });
  }, []);

  return (
    <ErrorHandler location="src/widgets/RiskRecords/DataContainment/components/Table/Table.jsx">
      <TableComponent
        {...{
          accessor: 'dataContainment',
          columns,
          configuration,
          rows,
        }}
      />
    </ErrorHandler>
  );
}
